module.exports = __webpack_public_path__ + "media/ที่เห็นนี้คือพลาสติก.655bb383.mp3";